import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { findDOMNode } from 'react-dom';
export function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null && ref !== void 0 && ref.hasOwnProperty('current')) {
    // @ts-ignore
    ref['current'] = value;
  }
}
export function getRef(ref) {
  if (!ref) return null;
  return 'current' in ref ? ref.current : ref;
}
export function useCallbackRef(initialValue, callback) {
  var _React$useState = React.useState(function () {
      return {
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
          get current() {
            return ref.value;
          },
          set current(value) {
            var last = ref.value;
            if (last !== value) {
              ref.value = value;
              ref.callback(value, last);
            }
          }
        }
      };
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    ref = _React$useState2[0];
  // update callback
  ref.callback = callback;
  return ref.facade;
}
export function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return React.useCallback(function (refValue) {
    var uniqueRefs = _toConsumableArray(new Set(refs));
    uniqueRefs.forEach(function (ref) {
      return setRef(ref, refValue);
    });
  }, refs);
}
export function forkRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  if (refs.every(function (ref) {
    return ref == null;
  })) {
    return null;
  }
  return function (refValue) {
    var uniqueRefs = _toConsumableArray(new Set(refs));
    uniqueRefs.forEach(function (ref) {
      return setRef(ref, refValue);
    });
  };
}
export function getNodeByRef(ref) {
  if (typeof ref === 'function') {
    ref = ref();
  }
  if (!ref) return null;
  var node = getRef(ref);
  if (!node) return null;
  if (node.nodeType === 1) return node;
  if (Object.keys(node).length === 1 && 'getBoundingClientRect' in node) return null;
  return findDOMNode(node);
}
//# sourceMappingURL=ref.mjs.map